export const PILOT_LAST_CONNECTION_CARD_FRENCH_LOCALE = {
  title: "Dernière connexion",
  ipAddress: "Adresse IP",
  status: "Status",
};
